import { BaseModel } from "sjs-base-model";
import ValoriModel from "./ValoriModel";

export default class AmountsDataModel extends BaseModel {
    public readonly impostaSostitutiva: ValoriModel = new ValoriModel({});
    public readonly bollo: number = 0;
    public readonly oneriPerRata: number = 0;
    public readonly speseIstruttoria: ValoriModel = new ValoriModel({});
    public readonly percentualeMaxSuMontante: ValoriModel = new ValoriModel({});
    public readonly interessiSuMontante: ValoriModel = new ValoriModel({});
    public readonly vaCapitale: number = 0;

    constructor(data: Partial<AmountsDataModel>) {
        super();

        this.update(data);
    }
}
